(function () {
  'use strict';

  var heroVideo = document.querySelector('.eco-hero__video');
  if (heroVideo) {
    if (!heroVideo.getAttribute('src')) {
      var srcSd = heroVideo.getAttribute('data-src-sd');
      var srcMd = heroVideo.getAttribute('data-src-md');
      var srcHd = heroVideo.getAttribute('data-src-hd');
      var chosenSrc = srcHd;
      if (window.matchMedia('(max-width: 749px)').matches) {
        chosenSrc = srcSd || srcMd || srcHd;
      } else if (window.matchMedia('(max-width: 1249px)').matches) {
        chosenSrc = srcMd || srcHd;
      }
      if (chosenSrc) {
        heroVideo.src = chosenSrc;
        heroVideo.load();
        heroVideo.play().catch(function () {});
      }
    }
    var markReady = function () { heroVideo.classList.add('eco-hero__video--ready'); };
    if (heroVideo.readyState >= 2) {
      markReady();
    } else {
      heroVideo.addEventListener('loadeddata', markReady, { once: true });
    }
  }

  var heroContent = document.querySelector('.eco-hero__content');
  if (heroContent) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { heroContent.classList.add('eco-in'); });
    });
  }

  document.querySelectorAll('[data-eco-hero-scroll]').forEach(function (heroScrollCue) {
    heroScrollCue.addEventListener('click', function () {
      var hero = document.querySelector('.eco-hero');
      var target = hero ? hero.nextElementSibling : null;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      }
    });
  });

  var productDesc = document.querySelector('.product__description');
  if (productDesc && productDesc.scrollHeight > 420) {
    var isSv = (document.documentElement.lang || '').indexOf('sv') === 0;
    var moreLabel = isSv ? 'Visa mer' : 'Näytä lisää';
    var lessLabel = isSv ? 'Visa mindre' : 'Näytä vähemmän';
    productDesc.classList.add('eco-desc-clamp');
    var descToggle = document.createElement('button');
    descToggle.type = 'button';
    descToggle.className = 'eco-desc-toggle';
    descToggle.textContent = moreLabel;
    descToggle.setAttribute('aria-expanded', 'false');
    productDesc.insertAdjacentElement('afterend', descToggle);
    descToggle.addEventListener('click', function () {
      var clamped = productDesc.classList.toggle('eco-desc-clamp');
      descToggle.textContent = clamped ? moreLabel : lessLabel;
      descToggle.setAttribute('aria-expanded', clamped ? 'false' : 'true');
    });
  }

  var headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    var lastScrolled = false;
    var onScroll = function () {
      var scrolled = window.scrollY > 8;
      if (scrolled !== lastScrolled) {
        headerWrapper.classList.toggle('eco-scrolled', scrolled);
        lastScrolled = scrolled;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.eco-reveal, .eco-material, .eco-colors').forEach(function (el) {
      el.classList.add('eco-in');
    });
    return;
  }

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('eco-in');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  document.querySelectorAll('.eco-reveal, .eco-material, .eco-colors').forEach(function (el, i) {
    el.style.setProperty('--eco-delay', (i % 6) * 70 + 'ms');
    revealObserver.observe(el);
  });

  document.querySelectorAll('[data-eco-bottle]').forEach(function (el, i) {
    el.style.setProperty('--i', i);
  });

  var counters = document.querySelectorAll('[data-eco-count]');
  if (counters.length) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var runCounter = function (el) {
      var target = parseFloat(el.getAttribute('data-eco-count'));
      var decimals = parseInt(el.getAttribute('data-eco-decimals') || '0', 10);
      if (reduceMotion) {
        el.textContent = target.toFixed(decimals);
        return;
      }
      var duration = 1400;
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    };
    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  var ecoReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ecoFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (ecoFinePointer && !ecoReduce) {
    document.querySelectorAll('.eco-cat').forEach(function (card) {
      var glare = document.createElement('span');
      glare.className = 'eco-cat__glare';
      glare.setAttribute('aria-hidden', 'true');
      card.appendChild(glare);
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () {
          card.style.transform =
            'perspective(90rem) rotateX(' + (py * -7).toFixed(2) + 'deg) rotateY(' + (px * 9).toFixed(2) + 'deg) translateY(-4px)';
          glare.style.opacity = '1';
          glare.style.transform = 'translate(' + (px * 60).toFixed(1) + '%, ' + (py * 60).toFixed(1) + '%)';
        });
      });
      card.addEventListener('mouseleave', function () {
        if (raf) window.cancelAnimationFrame(raf);
        card.style.transform = '';
        glare.style.opacity = '0';
      });
    });
  }

  var heroMediaEl = document.querySelector('.eco-hero__media');
  var heroRootEl = document.querySelector('.eco-hero');
  if (heroMediaEl && heroRootEl && !ecoReduce) {
    var heroTicking = false;
    var heroParallax = function () {
      if (heroTicking) return;
      heroTicking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var h = heroRootEl.offsetHeight || 1;
        if (y <= h) {
          heroMediaEl.style.transform = 'translateY(' + (y * 0.28).toFixed(1) + 'px)';
        }
        heroTicking = false;
      });
    };
    window.addEventListener('scroll', heroParallax, { passive: true });
  }

  var stickyBar = document.querySelector('[data-eco-sticky-atc]');
  if (stickyBar) {
    var trigger = document.querySelector('[data-eco-sticky-trigger]');
    if (trigger) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('eco-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      stickyObserver.observe(trigger);
    }

    var stickyBtn = stickyBar.querySelector('[data-eco-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var mainForm = document.querySelector('product-form form, form[action*="/cart/add"]');
        if (mainForm) {
          var submit = mainForm.querySelector('[type="submit"]');
          if (submit) {
            submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
            window.setTimeout(function () { submit.click(); }, 400);
            return;
          }
        }
      });
    }
  }
})();
